import { IconButton, styled } from "@mui/material";
import React, { useState } from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";

const Input = styled("input")({
  display: "none",
});

const ProductImageForm = ({
  productMultiImages,
  setProductMultiImages,
  selectedMultiImages,
  setSelectedMultiImages,
}) => {
  const onSelectedFile = (event) => {
    const selectedFiles = event.target.files;
    const selectedFilesArray = Array.from(selectedFiles);

    const imagesArray = selectedFilesArray.map((file) => {
      return URL.createObjectURL(file);
    });
    setProductMultiImages((prevState) => prevState.concat(selectedFilesArray));
    setSelectedMultiImages((previousImages) =>
      previousImages.concat(imagesArray)
    );
  };
  return (
    <Stack direction='column'>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 5,
        }}
      >
        <Box alignSelf={"center"}>
          <label htmlFor='upload-file'>
            <Button variant='contained' component='span' color='error'>
              Upload Product Images
            </Button>
          </label>
          <Input
            accept='image/*'
            id='upload-file'
            multiple
            type='file'
            onChange={onSelectedFile}
          />
        </Box>

        {/* {selectedMultiImages.length > 0 &&
          (selectedMultiImages.length > 5 ? (
            <p>
              You can't upload more than 5 images! <br />
              <span>
                please delete <b>{selectedMultiImages.length - 5}</b> of them
              </span>
            </p>
          ) : (
            <Button
              onClick={() => {
                console.log("UPLOAD IMAGES");
              }}
            >
              UPLOAD {selectedMultiImages.length} IMAGE
              {selectedMultiImages.length === 1 ? "" : "S"}
            </Button>
          ))} */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 5,
          }}
        >
          {selectedMultiImages &&
            selectedMultiImages.map((image, index) => {
              return (
                <Box
                  key={image}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <img
                    src={image}
                    alt=''
                    style={{
                      objectFit: "contain",
                    }}
                    height='150'
                    width='180'
                  />
                  <Button
                    variant='contained'
                    onClick={() =>
                      setSelectedMultiImages(
                        selectedMultiImages.filter((e) => e !== image)
                      )
                    }
                  >
                    <DeleteTwoToneIcon color='error' />
                  </Button>
                </Box>
              );
            })}
        </Box>
        {/* <Button variant='contained' component='span'>
          Choose File
        </Button> */}
      </Box>
    </Stack>
  );
};

export default ProductImageForm;
